<template>
  <div class="exchangeRateInfoDetail">
    <van-form label-width="120px" :show-error="false" @submit="onSubmit">
      <van-field
        :label="$t.meta.currency"
        :value="currencyStr"
        :placeholder="$t.meta.select"
        @click-input="onShowEmit('exchangeRateInfoDetailCurrency')"
        readonly
        required
        :rules="formRule"
      >
      </van-field>

      <van-field
        v-model="form.ExchangeRate"
        :label="$t.exchangeRateInfo.rate"
        :placeholder="$t.meta.input"
        required
        :rules="formRule"
      />

      <option-list
        event="exchangeRateInfoDetailCurrency"
        :options="currencyList"
        @onSelect="onSelectCurrency"
      ></option-list>

      <div style="margin: 16px">
        <van-button round block type="info" native-type="submit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image } from "vant";
import OptionList from "@components/optionList/OptionList.vue";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image);

export default {
  name: "exchangeRateInfoDetail",
  components: {
    OptionList,
  },
  data() {
    return {
      CompanyId: JSON.parse(localStorage.getItem("auth")).userInfo.CompanyId,
      UserId: JSON.parse(localStorage.getItem("auth")).userInfo.UserId,
      form: {},
      formRule: [
        {
          required: true,
          message: this.$t.meta.require,
        },
      ],
      currencyStr: "",
      currencyList: [],
    };
  },
  created() {
    this.form = {
      Currency: "",
      ExchangeRate: "",
    };
    this.getCurrencyList();
  },
  methods: {
    onSelectCurrency(item) {
      this.form.Currency = item.value;
      this.currencyStr = item.text;
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.$api.financialManagement
          .getSystemAvailableCurrencyList()
          .then((res) => {
            var result = [];
            res.data.forEach((item) => {
              let data = {
                text: item.CurrencySn,
                value: item.SCId,
              };
              result.push(data);
            });
            this.currencyList = result;
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = this.form;
      param.CompanyId = this.CompanyId;
      param.UserId = this.UserId;
      param.CurrencySn = this.currencyStr;
      this.$api.financialManagement
        .addExchangeRate(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.data,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.exchangeRateInfoDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
